import React, { useState } from 'react'
import * as styles from './Grid.module.scss'
import { Link } from 'gatsby'
import kebabCase from 'lodash/kebabCase'

const climateToolsTags = [
  'All',
  'Risk Assessment',
  'Climate Data',
  'Water Resources',
  'Environmental Monitoring',
  'Geospatial Analysis'
]

const ClimateToolsGrid = ({ data }) => {
  const [selectedTag, setSelectedTag] = useState('All')

  const handleFilterClick = (tag) => {
    setSelectedTag(tag)
  }

  const filteredData =
    selectedTag !== 'All'
      ? data.filter((m) => m.tags.includes(selectedTag))
      : data

  return (
    <div className={styles.section}>
      <div className={styles.content}>
        <div className={styles.filterContainer}>
          {climateToolsTags.map((tag, index) => (
            <div
              key={tag}
              className={`${styles.filter} ${selectedTag === tag ? styles.active : ''} ${index === 0 ? styles.first : ''} ${index === climateToolsTags.length - 1 ? styles.last : ''}`}
              onClick={() => handleFilterClick(tag)}
            >
              {tag}
            </div>
          ))}
        </div>
        <div>
          <div className={styles.grid}>
            {filteredData.map((m) => (
              <GridItem
                key={m.title}
                title={m.title}
                tags={m.tags}
                excerpt={m.excerpt}
                image={m.featuredImage}
                link={`/climate-tools/${kebabCase(m.title)}/`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

const GridItem = ({ title, excerpt, link, image, tags }) => {
  const [hover, setHover] = useState(false)
  return (
    <Link to={link}>
      <div
        className={styles.postCard}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
      >
        <div className={`${styles.cardContent} ${hover && styles.hovered}`}>
          <h3>{title}</h3>
          <p>{excerpt}</p>
        </div>
        <div className={styles.cardTags}>
          {tags?.map((tag, index) => (
            <span key={tag}>
              <span className={styles.tag}>{tag}</span>
              {index < tags.length - 1 && ', '}
            </span>
          ))}
        </div>
      </div>
    </Link>
  )
}

export default ClimateToolsGrid
